import { Component, HostListener, OnInit, Inject, ViewChild, ElementRef, Renderer2, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidator } from './../../_common/custom-validators';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api-data.service';
import { URLS } from '../../_config/api.config';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
})

export class HomeComponent implements OnInit {

    private subscription: Subscription = new Subscription();
    
    public formData = [];
    isScrolled: boolean = false;
    homeLoader: boolean = false;
    dummyWillForm =
        {
            "_id": "644fb5526c87cc56a49558d2",
            "title": "Will",
            "description": "<p><span style=\"color:#c0392b\"><strong><span style=\"font-size:22px\">100+ wills created&nbsp;&nbsp;|&nbsp; $10B+ Committed to nonprofits</span></strong></span></p>\n\n<p><span style=\"font-size:18px\">In as little as 18 minutes, walk through the steps of creating a Will with our easy to use web form.</span></p>\n\n<ul>\n\t<li><span style=\"font-size:18px\">Catholic Legacy is a trusted partner, having vetted our service with world class attorneys and Doctors of Canon Law.</span></li>\n\t<li><span style=\"font-size:18px\">Being a non-profit, we are able to offer this service free as a part of our mission to help Catholics prepare for the future.</span></li>\n</ul>\n",
            "isActive": true,
            "status": "Published",
            "image": "https://catholiclw-qa-static.s3.ap-south-1.amazonaws.com/forms/image/Group%2011669-1684305466675.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQFGFINZXX5WQPUSU%2F20230605%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20230605T060325Z&X-Amz-Expires=604800&X-Amz-Signature=7d1f4fb04c07d863a6f0573327729c32b4a051b2991bd5103775901814e3f3ab&X-Amz-SignedHeaders=host",
            "samplePdf": "https://catholiclw-qa-static.s3.ap-south-1.amazonaws.com/forms/sample/other1684242785331-1684317654490.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQFGFINZXX5WQPUSU%2F20230605%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20230605T060325Z&X-Amz-Expires=604800&X-Amz-Signature=2607232f3b5bbed156cf2bcbca423f0c9d22774c6447ddd713f6c5d2412014a5&X-Amz-SignedHeaders=host",
            "buttonLabel": "CREATE MY FREE WILL",
            "userFormCompleted": 1,
            "updated_at": "2023-05-31T22:19:51.143Z",
            "updated_by": "Catholic Legacy Relevant Radio Admin",
            "created_by": "Catholic Legacy Relevant Radio Admin",
            "created_at": "2023-05-16T16:48:43.334Z"
        }
    dummyFuneralForm =
        {
            "_id": "644fb6eb8045be6a9444df82",
            "title": "Funeral Planner",
            "description": "<p><strong><span style=\"color:#c0392b\"><span style=\"font-size:22px\">60k+ People Planned funeral</span></span></strong></p>\n\n<p><span style=\"font-size:20px\">A free guide to make your intentions known and make the process easier for your loved ones at a difficult time.</span></p>\n\n<ul>\n\t<li><span style=\"font-size:20px\">Make preparations for Masses to be said for you soul.</span></li>\n\t<li><span style=\"font-size:20px\">This planning guide can also be used to make arrangements for a loved one that has already passed away.</span></li>\n</ul>\n",
            "isActive": true,
            "status": "Published",
            "image": "https://catholiclw-qa-static.s3.ap-south-1.amazonaws.com/forms/image/Group%2011669%402x-1684306961058.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQFGFINZXX5WQPUSU%2F20230614%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20230614T085315Z&X-Amz-Expires=604800&X-Amz-Signature=7fa00987a46caa787ff53c11324c43118cc7aa9e92385a6ac3ef19a8161543ef&X-Amz-SignedHeaders=host",
            "buttonLabel": "CREATE A PLAN NOW",
            "userFormCompleted": 0,
            "updated_at": "2023-05-17T07:25:20.572Z",
            "updated_by": "Admin Catholic Legacy ",
            "created_by": "Admin Catholic Legacy ",
            "created_at": "2023-05-01T16:42:37.684Z"
        }
    dummyHealthForm =
        {
            "_id": "644fb7778045be6a9444df84",
            "title": "Healthcare Directive",
            "description": "<p><strong><span style=\"color:#c0392b\"><span style=\"font-size:22px\">250+ Completed Health Care</span></span></strong></p>\n\n<p><span style=\"font-size:20px\">Also known as a living will, this allows you to have control over what happens to you when you can&rsquo;t speak for yourself</span></p>\n\n<ul>\n\t<li><span style=\"font-size:20px\">Don&rsquo;t let the government or hospitals make decisions for you that will violate your faith.</span></li>\n\t<li><span style=\"font-size:20px\">Prevent expensive healthcare costs from treatments you don&#39;t need.</span></li>\n</ul>\n",
            "isActive": true,
            "status": "Published",
            "image": "https://catholiclw-qa-static.s3.ap-south-1.amazonaws.com/forms/image/Group%2011669%402x-1684307024196.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQFGFINZXX5WQPUSU%2F20230614%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20230614T085315Z&X-Amz-Expires=604800&X-Amz-Signature=0be333ec5de2c1279be8b2fef3eee73cff9958e577ba5df6130a12e2448f1bf5&X-Amz-SignedHeaders=host",
            "buttonLabel": "DESIGN MY FREE HEALTHCARE DIRECTIVE",
            "userFormCompleted": 0,
            "updated_at": "2023-05-17T07:25:35.886Z",
            "updated_by": "Admin Catholic Legacy ",
            "created_by": "Admin Catholic Legacy ",
            "created_at": "2023-05-01T16:48:43.334Z"
        }

    constructor(
        private formBuilder: UntypedFormBuilder,
        private dataService: ApiService,
        private toastr: ToastrService,
        private router: Router,
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private el: ElementRef,
        private commonService: CommonService,
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    ngOnInit(): void {
        // const offset = this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;  
        // if(offset === 0){
        //   document.getElementsByTagName("body")[0].style.overflowY="hidden";
        // }
        this.isUserTokenValid();
        this.getHomepageFormData();

        // if (isPlatformBrowser(this.platformId)) {

        //     const spans = this.el.nativeElement.querySelectorAll('h3 span');

        //     let currentSpanIndex = 0;

        //     const animateSpan = () => {
        //         if (currentSpanIndex >= spans.length) {
        //             currentSpanIndex = 0;
        //         }

        //         const currentSpan = spans[currentSpanIndex];
        //         const animationDuration = 3500; // Adjust the duration of text appearing

        //         this.renderer.setStyle(
        //             currentSpan,
        //             'animation',
        //             `slideIn ${animationDuration}ms forwards`
        //         );

        //         setTimeout(() => {
        //             this.renderer.removeStyle(currentSpan, 'animation');
        //             currentSpanIndex++;
        //             animateSpan();
        //         }, animationDuration + 200); // Adjust the delay between animations as needed
        //     };

        //     // Start the animation
        //     animateSpan();

        //     const schema = {
        //         "@context": "https://schema.org",
        //         "@type": "BreadcrumbList",
        //         "itemListElement": [
        //             {
        //                 "@type": "ListItem",
        //                 "position": 1,
        //                 "name": "Home",
        //                 "item": environment.webUrl
        //             }
        //         ]
        //     };

        //     const script = this.renderer.createElement('script');
        //     script.type = 'application/ld+json';
        //     script.text = JSON.stringify(schema);
        //     this.renderer.appendChild(this.document.head, script);

        // }

    }

        // this.observeScroll();

    ngAfterViewInit() {
        let isVideo;
        let isArticle;
        // this.route.queryParams.subscribe(params => {
        //     isVideo = params.isVideo ? params.isVideo : '';
        //     isArticle = params.isArticle ? params.isArticle : '';
        // });

        isVideo = this.route.snapshot.paramMap.get('isVideo') ? this.route.snapshot.paramMap.get('isVideo') : '';
        isArticle = this.route.snapshot.paramMap.get('isArticle') ? this.route.snapshot.paramMap.get('isArticle') : '';

        if (isVideo) {
            setTimeout(() => {
                const videoSection = this.elementRef.nativeElement.querySelector('#videoSection');
                videoSection.scrollIntoView({ behavior: 'smooth' });
            }, 1000);
        } else if (isArticle) {
            setTimeout(() => {
                const videoSection = this.elementRef.nativeElement.querySelector('#videoSection');
                videoSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }, 1000);
        }

        if (isPlatformBrowser(this.platformId)) {
            const spans = this.el.nativeElement.querySelectorAll('h3 span');
            let currentSpanIndex = 0;
    
            const animateSpan = () => {
                spans.forEach((span, index) => {
                    this.renderer.setStyle(span, 'opacity', '0');
                    this.renderer.setStyle(span, 'transform', 'translateY(50px)');
                    this.renderer.setStyle(span, 'position', 'absolute');
                });
    
                const currentSpan = spans[currentSpanIndex];
                this.renderer.setStyle(currentSpan, 'opacity', '1');
                this.renderer.setStyle(currentSpan, 'transform', 'translateY(0)');
                this.renderer.setStyle(currentSpan, 'transition', 'transform 0.4s ease-in-out, opacity 1s');
    
                setTimeout(() => {
                    this.renderer.setStyle(currentSpan, 'opacity', '0');
                    this.renderer.setStyle(currentSpan, 'transform', 'translateY(-50px)');
                    currentSpanIndex = (currentSpanIndex + 1) % spans.length;
                    setTimeout(animateSpan, 600); // Delay before showing the next span
                }, 3000); // Duration before switching text
            };
    
            animateSpan();
        }
    }

    isUserTokenValid() {
        let isValidToken = this.commonService.localStorageGet('accessToken');
        if (isValidToken) {
            this.subscription.add(
                this.dataService.get(URLS.getValidToken + '?token=' + isValidToken).subscribe(data => {
                    if (data['code'] == 200) {
                        if (!data['data'].isValid) {
                            this.commonService.localStorageClear();
                            this.router.navigate(['/login']);
                        }
                    } else {
                        this.toastr.error(data['message'], "Error");
                    }
                }, error => {
                    this.toastr.error(error['message'], "Error");
                })
            )
        }
    }

    getHomepageFormData() {
        this.homeLoader = true;
        this.subscription.add(
            this.dataService.get(URLS.getHomePageFormData).subscribe(data => {
                if (data['code'] == 200) {
                    data['data'].forEach(element => {
                        element.description = this.sanitizer.bypassSecurityTrustHtml(element.description);
                        element.statisticDescription = this.sanitizer.bypassSecurityTrustHtml(element.statisticDescription);
                        if (element._id === '6490049fe7bc6b6649320fe5') {
                            this.formData[0] = element;
                        }
                        // else {
                        //   this.formData[0] = this.dummyWillForm;
                        // } 
                        if (element._id === '64e2f30f463b8795bcf3a85f') {
                            this.formData[1] = element;
                        }
                        // else{
                        //   this.formData[1] = this.dummyFuneralForm;
                        // } 
                        if (element._id === '64ccdf603f11d4fb4c0174a8') {
                            this.formData[2] = element;
                        }
                        // else {
                        //   this.formData[2] = this.dummyHealthForm;
                        // }             
                    });
                    this.homeLoader = false;
                } else { 
                    this.homeLoader = false;
                    this.toastr.error(data['message'], "Error");
                }
            }, error => {
                this.homeLoader = false;
                this.toastr.error(error['message'], "Error");
            })
        )
    }

    getElementOffset(element) {
        if (element) {
            var de = this.document.documentElement;
            var box = element.getBoundingClientRect();
            var top = box.top + window.pageYOffset - de.clientTop;
            var left = box.left + window.pageXOffset - de.clientLeft;
            var scrollObj = {
                top: top,
                left: left,
                box: box,
                offset: window.pageYOffset
            }
            return scrollObj;
        }
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(ev) {
        const scrollPosition = window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
        this.isScrolled = scrollPosition > 0;

        const mediaQuery = window.matchMedia('(min-width: 991px)')
        // Check if the media query is true
        if (mediaQuery.matches) {

            var scrollTop = this.getElementOffset(this.document.getElementById("scrollFirst"));

            if (scrollTop && scrollTop.offset) {
                if (scrollTop.offset > 250) {
                    this.document.getElementById('scrollFirst').classList.add("fade-in");
                    this.document.getElementById('scrollFirst').classList.remove("fadeOut");
                } else {
                    this.document.getElementById('scrollFirst').classList.add("fadeOut");
                    // this.document.getElementById('scrollFirst').classList.remove("fade-in");      
                }

                if (scrollTop.offset > 950) {
                    this.document.getElementById('scrollSecond').classList.add("fade-in");
                    this.document.getElementById('scrollSecond').classList.remove("fadeOut");
                } else {
                    this.document.getElementById('scrollSecond').classList.add("fadeOut");
                    // this.document.getElementById('scrollSecond').classList.remove("fade-in");
                }

                if (scrollTop.offset > 1500) {
                    this.document.getElementById('scrollThird').classList.add("fade-in");
                    this.document.getElementById('scrollThird').classList.remove("fadeOut");
                } else {
                    this.document.getElementById('scrollThird').classList.add("fadeOut");
                    // this.document.getElementById('scrollThird').classList.remove("fade-in");
                }
            }

            // if (scrollTop.offset > 600 && scrollTop.offset < 900) {
            //   this.document.getElementById('scrollFirst').classList.add("fade-in");
            //   this.document.getElementById('scrollFirst').classList.remove("fade-out");
            // } else {
            //   this.document.getElementById('scrollFirst').classList.add("fade-out");
            //   this.document.getElementById('scrollFirst').classList.remove("fade-in");      
            // }

            // if (scrollTop.offset > 1300 && scrollTop.offset < 1600) {
            //   this.document.getElementById('scrollSecond').classList.add("fade-in");
            //   this.document.getElementById('scrollSecond').classList.remove("fade-out");
            // } else {
            //   this.document.getElementById('scrollSecond').classList.add("fade-out");
            //   this.document.getElementById('scrollSecond').classList.remove("fade-in");
            // }

            // if (scrollTop.offset > 2050 && scrollTop.offset < 2350) {
            //   this.document.getElementById('scrollThird').classList.add("fade-in");
            //   this.document.getElementById('scrollThird').classList.remove("fade-out");
            // } else {
            //   this.document.getElementById('scrollThird').classList.add("fade-out");
            //   this.document.getElementById('scrollThird').classList.remove("fade-in");
            // }
        }
    }

    scroll(el: HTMLElement) {
        el.scrollIntoView();
        this.document.getElementsByTagName("body")[0].style.overflowY = "scroll";
    }

    // @HostListener("window:scroll", [])
    // onWindowScroll() {
    //   const offset = this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    //   if(offset === 0){
    //     this.document.getElementsByTagName("body")[0].style.overflowY="hidden";
    //   }
    // }

    goToForm(id) {
        // this.router.navigate(['my-forms']);
        //this.commonService.localStorageSet('my-form-status-id', id);

        const userId = this.commonService.localStorageGet('userId')
        if (!userId) {
            sessionStorage.setItem('formId', id);
        }
        this.commonService.localStorageSet('my-form-status-id', id);
        this.router.navigate(['my-forms']);
    }

}